<template>
    <div>
        <p v-if="filters">
            Filtres : {{filters}}
        </p>

        <b-table v-show="data.length > 0" striped hover :items="data" :fields="[
            {
                key: column_name,
                label: 'Nom',
                thStyle: { width: '20%' }
            },
            {
                key: column_image_reference,
                label: 'Référence',
                tdStyle: { width: '15%' }
            },
            {
                key: 'result',
                label: 'Résultats',
                tdStyle: { width: '65%' }
            },
            {
                key: 'custom_column',
                label: '',
                tdStyle: { width: '5%' }
            },
        ]">
            <template v-slot:[`cell(${column_image_reference})`]="data">
                <img style="max-width: 100px" :src="data.item[column_image_reference]" />
            </template>
            <template v-slot:cell(result)="data">
                 <div v-show="!data.item.list">
                    <div v-for="(youtube, idx) in data.item.result.slice(0, 5)" :key="idx" :style="'display: inline-block; background-color:' + (blacklist.includes(youtube.channel_link) ? 'rgba(255, 0, 0, 0.2)' : whitelist.includes(youtube.channel_link) ? 'rgba(0, 255, 0, 0.2)' : 'inherit')">
                        <b-button @click="setYoutube(youtube)" variant="link"><img :id="uid+'youtube_' + youtube.id" style="max-width: 100px" :src='"https://img.youtube.com/vi/" + youtube.url.replace(/.*\//, "").replace(/.*v=/, "").replace(/&.*/, "") + "/hqdefault.jpg"' /></b-button><br />
                        <div>{{youtube.channel_name}}</div>
                        <div>{{youtube.views}} vues</div>
                        <b-tooltip custom-class="long-tooltip" :target="uid+'youtube_' + youtube.id">
                            Url: {{ youtube.url}}<br />
                            Titre : {{ youtube.title}}<br />
                            Description: {{ youtube.description}}<br />
                            Nom de la chaîne : {{ youtube.channel_name}}<br />
                            Adresse de la chaîne: {{youtube.channel_link}}<br />
                            Nombre de vues : {{ youtube.views}}<br />
                            Publication: {{ youtube.published_date}} (au {{ youtube.get_date}})<br />
                            Durée: {{ youtube.length}}<br />
                            Extensions: {{ youtube.extensions ?  youtube.extensions.join(", ") : ""}}<br />
                            Position de la recherche: {{youtube.position}}<br />
                            Score: {{youtube.score}}
                        </b-tooltip>
                    </div>
                </div>
                <div v-show="data.item.list">
                    <div v-for="(youtube, idx) in data.item.result" :key="idx">
                        <b-button @click="setYoutube(youtube)" :id="uid+'youtubel_' + youtube.id" variant="link" :style="'text-align:left; color:' + (blacklist.includes(youtube.channel_link) ? 'rgba(255, 0, 0, 1)' : whitelist.includes(youtube.channel_link) ? 'rgba(0, 255, 0, 1)' : 'inherit')">{{youtube.channel_name}} - {{youtube.title}}</b-button><br />
                        <b-tooltip custom-class="long-tooltip" :target="uid+'youtubel_' + youtube.id">
                            Url: {{ youtube.url}}<br />
                            Titre : {{ youtube.title}}<br />
                            Description: {{ youtube.description}}<br />
                            Nom de la chaîne : {{ youtube.channel_name}}<br />
                            Adresse de la chaîne: {{youtube.channel_link}}<br />
                            Nombre de vues : {{ youtube.views}}<br />
                            Publication: {{ youtube.published_date}} (au {{ youtube.get_date}})<br />
                            Durée: {{ youtube.length}}<br />
                            Extensions: {{ youtube.extensions ?  youtube.extensions.join(", ") : ""}}<br />
                            Position de la recherche: {{youtube.position}}<br />
                            Score: {{youtube.score}}
                        </b-tooltip>
                    </div>
                </div>
            </template>
            <template  v-slot:cell(custom_column)="data">
                <b-button v-if="!data.item.list" @click="setList(data.item, 'list', true)">Liste</b-button>
                <b-button v-else @click="setList(data.item, 'list', false)">Image</b-button>
            </template>
        </b-table>

        <b-modal ok-only :id="uid+'youtube'" title="Visualisation" size="xl">
            <b-container style="margin: 0; padding: 0; max-width: none" v-if="youtube">
                <b-row>
                    <b-col cols="5">
                        <div>Image de référence</div>
                        <img style="max-width: 100%; max-height: 500px" :src="youtube.ref" />
                    </b-col>
                    <b-col cols="7">
                        <div>Youtube</div>

                        <div v-if="youtube">
                            <iframe width="100%" height="480" :src="'https://www.youtube.com/embed/' + youtube.url.replace(/.*\//, '').replace(/.*v=/, '').replace(/&.*/, '')" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture;" allowfullscreen></iframe>
                            
                            <p>
                                Url: {{ youtube.url}}<br />
                                Titre : {{ youtube.title}}<br />
                                Description: {{ youtube.description}}<br />
                                Nom de la chaîne : {{ youtube.channel_name}}<br />
                                Adresse de la chaîne: {{youtube.channel_link}}<br />
                                Nombre de vues : {{ youtube.views}}<br />
                                Publication: {{ youtube.published_date}} (au {{ youtube.get_date}})<br />
                                Durée: {{ youtube.length}}<br />
                                Extensions: {{ youtube.extensions ?  youtube.extensions.join(", ") : ""}}<br />
                                Position de la recherche: {{youtube.position}}<br />
                                Score: {{youtube.score}}
                            </p>

                            <b-button @click="add(youtube.channel_link, 'blacklist')">Ajouter en blacklist</b-button>&nbsp;
                            <b-button @click="add(youtube.channel_link, 'whitelist')">Ajouter en whitelist</b-button>&nbsp;
                            <b-button @click="add(youtube.channel_link, '')">Rendre neutre</b-button>
                        </div>
                    </b-col>
                </b-row>
            </b-container>
        </b-modal>
    </div>
</template>

<script>

    export default {
		components: {
        },
        props: {
            filters: {
                default: '',
                type: String
            },
            data: {
				default: () => []
            },
            column_image_reference: {
                default: '',
                type: String
            },
            column_name: {
                default: '',
                type: String
            },
            column_brand: {
                default: '',
                type: String
            },
            whitelist: {
				default: () => []
            },
            blacklist: {
				default: () => []
            },
        },
		data() {
			return {
                uid: this.$uuid.v4(),
                youtube: null
            }
        },
        methods: {
            setList(item, key, value)
            {
                this.$set(item, key, value);
            },
            setYoutube(youtube)
            {
                this.youtube = youtube;
                this.$bvModal.show(this.uid+"youtube")
            },
            add(element, type)
            {
                this.$emit("add", element, type, false, true);
            }
        },
		mounted: async function () {

        }
    }
</script>

<style scoped>
	.center_spinner {
		width: 0%;
		margin: 0 auto;
        margin-bottom: 60px;
	}

    .long-tooltip .tooltip-inner
    {
        max-width: 600px !important;
        text-align: left !important;
    }
    .table-striped > tbody > tr:nth-child(2n+1) > td, .table-striped > tbody > tr:nth-child(2n+1) > th {
        background-color: WhiteSmoke;
    }

</style>